import { useCallback, useEffect, useMemo, useRef, useState } from "react";
export const useDrop = (opts) => {
  const optsRef = useRef(opts);
  optsRef.current = opts;
  const [hoverProp, setHoverProp] = useState("");
  const [isHovering, setIsHovering] = useState("");
  const [hoverPos, setHoverPos] = useState("bottom");
  const dropProps = useMemo(
    () => ({
      onDrop: (e) => {
        e.preventDefault();
        e.persist();
        const isFiles = e.dataTransfer.types.includes("Files");
        if (isFiles) {
          return;
        }
        if (optsRef.current.onDrop) {
          optsRef.current.onDrop(
            e.dataTransfer.getData("dragProp"),
            e.dataTransfer.getData("dragData"),
          );
          setIsHovering(false);
        }
      },
      onDragEnter: (e) => {
        e.preventDefault();
        e.persist();
        const hoverProp = e.currentTarget.dataset.levelInfo;
        setHoverProp(hoverProp);
        setIsHovering(true);
      },
      onDragLeave: () => {
          setHoverProp("");
          setIsHovering(false);
      },
      onDragOver: (e) => {
        e.preventDefault();
        var rect = e.currentTarget.getBoundingClientRect();
        var y = e.clientY - rect.top;
        const pos = y > rect.height / 2 ? "bottom" : "top";
        setHoverPos(pos);
        setIsHovering(true);
      },
    }),
    [optsRef, setHoverProp],
  );
  return { dropProps, hoverProp, isHovering, hoverPos, setHoverProp };
};
export const useDrag = (opts) => {
  const optsRef = useRef(opts);
  optsRef.current = opts;
  const getDragProps = useCallback(
    (prop, data) => {
      return {
        key: JSON.stringify(prop),
        draggable: "true",
        onDragStart: (e) => {
          optsRef.current.onDragStart && optsRef.current.onDragStart(prop, data);
          e.dataTransfer.setData("dragProp", prop);
          e.dataTransfer.setData("dragData", data ? JSON.stringify(data) : "");
        },
      };
    },
    [optsRef],
  );
  return getDragProps;
};

function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;

  return ref;
}


export interface Options {
  onDragStart?: (event: React.DragEvent) => void;
  onDragEnd?: (event: React.DragEvent) => void;
  dragImage?: {
    image: string | Element;
    offsetX?: number;
    offsetY?: number;
  };
}

export const useDragRef = (data, ref, options: Options) => {
  const optionsRef = useLatest(options);
  const dataRef = useLatest(data);
  useEffect(() => {

  }, []);
}
